import { render, staticRenderFns } from "./InventoryItemCreate.vue?vue&type=template&id=7b4bfb0a&scoped=true&"
import script from "./InventoryItemCreate.vue?vue&type=script&lang=js&"
export * from "./InventoryItemCreate.vue?vue&type=script&lang=js&"
import style0 from "./InventoryItemCreate.vue?vue&type=style&index=0&id=7b4bfb0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4bfb0a",
  null
  
)

export default component.exports